<template>
  <div id="app" :class="selectClass" class="ebi-not-card-light">
    <!-- <el-alert style="position: absolute;z-index: 1000;" v-if="$store.state.LicenseStatus" :title="checkMsg || $translate('authStatusAbnormal')" center :closable="false" type="warning"></el-alert> -->
    <!-- 隐藏client端的系统过期警告，只在admin端菜显示 -->
    <!-- <el-alert style="position: absolute;z-index: 1000;color: #ffffff;background: linear-gradient(139deg, #fb8817, #ff4b01, #c12127)" v-if="LicenseStatusOver" :title="$translate('systemExpirationTime') + expireTime" center :closable="true" type="warning"></el-alert> -->
    <linear-progress v-if="$store.state.globalLoading" style="position: absolute;z-index: 9999;"></linear-progress>
    <!-- <timeOut v-if="$store.state.timeOut" />TODO:暂时未完善404或者超时的请求 -->
    <router-view :id="id" />
  </div>
</template>

<script>
import linearProgress from "./components/linearProgress";
export default {
  components: { linearProgress },
  data() {
    return {
      LicenseStatusOver: false,
      expireTime: "",
      checkMsg: "",
      watermarkTimer: null,
    };
  },
  computed: {
    id() {
      let themeId = this.$store.state.theme ? this.$store.state.theme : "";
      return themeId;
    },
    selectClass() {
      if (this.$store.state.systemType === "ATL") {
        return "ATL";
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss">
@import "./assets/css/reset.scss";
@import "./assets/css/main.scss";
@import "./assets/css/media.scss";
</style>
